<style>
  .load-more {
    padding: 16px;
    margin: 16px 0;
    background: #eee;
    cursor: pointer;
    width: auto;
    text-align: center;
    display: inline-block;
    font-family: proxima-nova, sans-serif;
    font-size: 13px;
    font-weight: 500;
    border-radius: 4px;
  }
</style>

<div on:click class="load-more">Load More</div>